import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateWeekApi } from "../../../../api/week";
import { getAccessToken } from "../../../../api/auth";

import "./EditWeekForm.scss";

export default function EditWeekForm(props) {
  const { week, setIsVisibleModal, setReloadWeeks } = props;
  const [weekData, setWeekData] = useState({});

  //trae los datos de semana
  useEffect(() => {
    setWeekData({
      week_code: week.week_code,
      description: week.description,
    });
  }, [week]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!weekData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateWeek = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let weekUpdate = weekData; //es let porque se va actualizando

      updateWeekApi(token, weekUpdate, week._id).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadWeeks(true);
        }
      });
    }
  };

  return (
    <div className="edit-week-form">
      <EditForm
        weekData={weekData}
        setWeekData={setWeekData}
        updateWeek={updateWeek}
      />
    </div>
  );
}

function EditForm(props) {
  const { weekData, setWeekData, updateWeek } = props;

  return (
    <Form className="form-edit" onSubmit={updateWeek}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={weekData.week_code}
              onChange={(e) => setWeekData({ ...weekData, week_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={weekData.description}
              onChange={(e) =>
                setWeekData({ ...weekData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateWeek}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
